import { requireAuth } from '@/features/auth/guards/require-auth'
import { ReferencesHub } from '@/features/references/components/references-hub'
import { operationsListQuery } from '@/features/references/operations/operations-query'
import { positionsListQuery } from '@/features/references/positions/positions-query'
import { unitsListQuery } from '@/features/references/units/units-query'
import { usersListQuery } from '@/features/references/users/users-query'
import { warehousesListQuery } from '@/features/references/warehouses/queries/warehouse-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'

/** «Довідники»: the tabs show every catalog's count, so all five load together. */
export const Route = createFileRoute('/_app/references')({
  beforeLoad: requireAuth,
  loader: ({ context }) => {
    const qc = context.queryClient
    return Promise.all([
      qc.ensureQueryData(usersListQuery()),
      qc.ensureQueryData(warehousesListQuery()),
      qc.ensureQueryData(positionsListQuery()),
      qc.ensureQueryData(operationsListQuery()),
      qc.ensureQueryData(unitsListQuery()),
    ])
  },
  component: ReferencesHub,
  staticData: { crumb: messages.crumbs.references },
})
